(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    

  const baseURL = "";

  window.onload = function() {

// Get the current URL of the parent page
    var url = window.location.href;

// Get the query string from the URL
    var queryString = url.split('?')[1];



// Create the iframe URL with the query string
    var iframeUrl = "https://hitched.gemist.co/designer/engagement?" + queryString;



// Set the iframe's source URL
    var iframe = document.getElementById("designer-iframe");
    if (!iframe) return;

    iframe.src = iframeUrl;
  };

  function removeItemsFromCart(items) {
    if (items.length<= 0) return;

  items.forEach(item => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      }).then(response => response.json()).then(data => {
        var event = new Event('cart:refresh');
        document.dispatchEvent(event);
      }).catch(() => {});
    }) 

    
  }

  window.addEventListener("cart:change", function(event) {
    let variant_id;
    event
      .detail
      .cart
      .items_removed
      .forEach(item => {
        variant_id = item.variant_id;
      });

    if (variant_id === undefined) {
      return;
    }

    fetch('/cart.js').then(response => response.json()).then(data => {
      let relatedItems = data.items.filter(item => item.properties._variant_id == variant_id);
      let removeItems = []
      relatedItems.forEach(item => {
        removeItems.push({
          id: item.key,
          quantity: item.quantity - 1
        });
      });

      removeItemsFromCart(removeItems);
    }).catch(() => {});
  });

  window.addEventListener("message", function(event) {
    const designerIframe = document.getElementById("designer-iframe");

    if (event.data) {
      try {
        const message = JSON.parse(event.data);
        switch (message.type) {
          case "buy":
            var id = message
              .product
              .Shopify
              .productVariant
              .split("/")
              .slice(-1)[0];
            var size = message.size;

            const ringItems = [];
            let product = {
              id: id,
              quantity: 1,
              properties: {
                Size: size,
                _gemist__ring: true,
              }
            };

            if (message.engravingText != "") {
              let engraving = {
                id: "46474912071921",
                quantity: 1,
                properties: {
                  Font: message.engravingFont,
                  Text: message.engravingText,
                }
              };

              product.properties.Engraving = message.engravingText;
              product.properties.EngravingFont = message.engravingFont;

              ringItems.push(engraving);
            }

            ringItems.push(product);

            cart = window.cart || document.querySelector("cart-notification") || document.querySelector("cart-drawer");

// Primera llamada para agregar el anillo al carrito
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(
                {items: ringItems}
              )
            }).then((response) => {
              if (cart && typeof cart.getCart === "function") {
                cart.getCart();
              }
              var event = new Event("cart:refresh");
              document.dispatchEvent(event);

              setTimeout(function() {
                document.dispatchEvent(event);
                window.location.href = "/cart";
              }, 3000);

              if (message.diamond.variantId !== undefined) {
                let diamond = {
                  id: message
                    .diamond
                    .variantId
                    .split("/")
                    .slice(-1)[0],
                  quantity: 1,
                  properties: {
                    _gemist__diamond: true,
                  }
                };

                fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(
                    {items: [diamond]}
                  )
                }).then((response) => {
                  if (cart && typeof cart.getCart === "function") {
                    cart.getCart();
                  }
                  var event = new Event("cart:refresh");
                  document.dispatchEvent(event);

                  setTimeout(function() {
                    document.dispatchEvent(event);

                  }, 3000);

                  designerIframe.contentWindow.postMessage({type: 'cart', status: 'added'}, '*',);

                }).catch(() => {});
              }
            }).catch(() => {});

            break;
          case 'favorite':
            var {
              id
            } = message.product;

            fetch(baseURL + 'api/products/' + id + '/shmetadata').then(response => response.json()).then(data => {
              var {
                productId,
                handle
              } = data;

// create element to save
              var elementToSave = document.createElement('div');
              elementToSave.dataset.id = productId.split('/').slice(-1)[0];
              elementToSave.dataset.handle = handle;

// use the saveWishlist function that we made available from theme.js
              saveWishlist($(elementToSave));
            }).catch(() => {});
            break;
          case 'updateParams':

// Get the parameter names from the message
            var paramNames = message.paramNames;
            var currentURL = new URL(window.location.href);

// Loop through the parameter names
            paramNames.forEach(function(paramName) {

// Retrieve the corresponding value from the message
              var paramValue = message[paramName];

// Modify the query parameter of the parent URL with the value
              if (paramValue !== undefined) {
                currentURL.searchParams.set(paramName, paramValue);
              }
            });

// Replace the parent URL with the modified URL
            window.history.replaceState({}, "", currentURL.toString());
            break;
          case 'download':
            const downloadHref = message.downloadHref;
            if (downloadHref) {
              window.open(downloadHref, "_blank");
            }
            break;
          case 'copywindowlocation':

// Get the current window location
            var windowLocation = window.location.href;

// Use the Clipboard API to copy the window location to the clipboard
            navigator
              .clipboard
              .writeText(windowLocation)
              .then(function() {})
              .catch(function() {});
            break;
          case 'sendemail':
            let {emailContent, subject, recipient} = message;
            const currentPageLink = window.location.href;
            emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);

            const mailtoLink = `mailto:${recipient}?subject=${
              encodeURIComponent(subject)
            }&body=${
              encodeURIComponent(emailContent)
            }`;

            if (mailtoLink) {
              window.open(mailtoLink, "_blank");
            }
            break;
          case "requestfullscreen":
            const designerIframe = document.querySelector("#designer-iframe");
            void designerIframe.requestFullscreen();
            break;
          default:
            break;
        }
      } catch (e) {
        void e;
      }
    }
  }, false);


// This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height,
// then subtracting their pixel values from the viewport's fullscreen space.
document.addEventListener("DOMContentLoaded", function() {
  const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const designerIFrameContainerElement = document.querySelector(".designer-iframe-container");
  const designerIFrameElement = document.querySelector("#designer-iframe");
  const selectorsToObserve = ["#shopify-section-sections--21045261238513__header", "#shopify-section-sections--22575381545201__header"];
  const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

  // Function to calculate total height including margins
  const calculateTotalHeight = () => {
    let totalHeight = 0;
    observedElements.forEach(element => {
      const style = getComputedStyle(element);
      const marginTop = parseFloat(style.marginTop) || 0;
      const marginBottom = parseFloat(style.marginBottom) || 0;
      totalHeight += element.offsetHeight + marginTop + marginBottom;
    });
    return totalHeight;
  };

  // Update iframe height
  const updateIframeHeight = () => {
    const totalHeight = calculateTotalHeight();
    if (designerIFrameContainerElement && designerIFrameElement && totalHeight) {
      const heightValueString = isMobileDevice 
        ? `calc(100dvh - ${totalHeight + 16}px)` 
        : `calc(100vh - ${totalHeight}px)`;
      
      designerIFrameContainerElement.style.height = heightValueString;
      designerIFrameElement.style.height = heightValueString;
    }
  };

  // Update on element resize
  const observer = new ResizeObserver(updateIframeHeight);
  observedElements.forEach(element => observer.observe(element));

  // Update on window resize (e.g., device rotation)
  window.addEventListener("resize", updateIframeHeight);
});

  } catch(e) { console.error(e); }
})();
})();
